(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__senbederFooterAccordionReady) return;
    window.__senbederFooterAccordionReady = true;

    const media = window.matchMedia('(max-width: 749px)');

    function syncFooter(footer) {
      footer.querySelectorAll('.senbeder-footer__accordion').forEach((accordion) => {
        const summary = accordion.querySelector(':scope > .senbeder-footer__accordion-summary');
        if (media.matches) {
          if (summary) summary.tabIndex = 0;
          if (accordion.dataset.mobileReady !== 'true') {
            accordion.open = false;
            accordion.dataset.mobileReady = 'true';
          }
        } else {
          if (summary) summary.tabIndex = -1;
          accordion.open = true;
          delete accordion.dataset.mobileReady;
        }
      });
    }

    function syncAll(root) {
      if (root && root.matches && root.matches('.senbeder-footer')) syncFooter(root);
      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.senbeder-footer').forEach(syncFooter);
    }

    function handleBreakpointChange() {
      document.querySelectorAll('.senbeder-footer').forEach(syncFooter);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => syncAll(document), { once: true });
    } else {
      syncAll(document);
    }

    if (media.addEventListener) media.addEventListener('change', handleBreakpointChange);
    else media.addListener(handleBreakpointChange);

    document.addEventListener('shopify:section:load', (event) => syncAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    if (window.__senbederHoverMenusInitialized) return;
    window.__senbederHoverMenusInitialized = true;

    const desktopQuery = window.matchMedia('(min-width: 990px)');
    let cleanup = () => {};

    const setMenuState = (details, open) => {
      if (!details) return;
      details.open = open;
      const summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    const closeMenuTree = (details) => {
      if (!details) return;
      details.querySelectorAll('details[open]').forEach((child) => setMenuState(child, false));
      setMenuState(details, false);
    };

    const initHoverMenus = () => {
      cleanup();
      if (!desktopQuery.matches) return;

      const disposers = [];
      document.querySelectorAll('.senbeder-header .header__inline-menu header-menu').forEach((menu) => {
        const root = menu.querySelector(':scope > details');
        if (!root) return;

        let closeTimer;
        const clearCloseTimer = () => window.clearTimeout(closeTimer);
        const openRoot = () => {
          clearCloseTimer();
          setMenuState(root, true);
        };
        const scheduleCloseRoot = () => {
          clearCloseTimer();
          closeTimer = window.setTimeout(() => closeMenuTree(root), 180);
        };

        menu.addEventListener('mouseenter', openRoot);
        menu.addEventListener('mouseleave', scheduleCloseRoot);
        menu.addEventListener('focusin', openRoot);
        const handleRootFocusOut = (event) => {
          if (!menu.contains(event.relatedTarget)) scheduleCloseRoot();
        };
        menu.addEventListener('focusout', handleRootFocusOut);
        disposers.push(() => {
          clearCloseTimer();
          menu.removeEventListener('mouseenter', openRoot);
          menu.removeEventListener('mouseleave', scheduleCloseRoot);
          menu.removeEventListener('focusin', openRoot);
          menu.removeEventListener('focusout', handleRootFocusOut);
        });

        root.querySelectorAll(':scope > .sen-product-catalog-menu__list > li > details, :scope > .sen-motorcycle-menu__brands > li > details').forEach((child) => {
          let childCloseTimer;
          const clearChildCloseTimer = () => window.clearTimeout(childCloseTimer);
          const openChild = () => {
            clearChildCloseTimer();
            clearCloseTimer();
            setMenuState(root, true);
            setMenuState(child, true);
          };
          const scheduleCloseChild = () => {
            clearChildCloseTimer();
            childCloseTimer = window.setTimeout(() => setMenuState(child, false), 180);
          };
          child.addEventListener('mouseenter', openChild);
          child.addEventListener('mouseleave', scheduleCloseChild);
          child.addEventListener('focusin', openChild);
          const handleChildFocusOut = (event) => {
            if (!child.contains(event.relatedTarget)) scheduleCloseChild();
          };
          child.addEventListener('focusout', handleChildFocusOut);
          disposers.push(() => {
            clearChildCloseTimer();
            child.removeEventListener('mouseenter', openChild);
            child.removeEventListener('mouseleave', scheduleCloseChild);
            child.removeEventListener('focusin', openChild);
            child.removeEventListener('focusout', handleChildFocusOut);
          });
        });
      });

      cleanup = () => disposers.splice(0).forEach((dispose) => dispose());
    };

    initHoverMenus();
    desktopQuery.addEventListener?.('change', initHoverMenus);
    document.addEventListener('shopify:section:load', initHoverMenus);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-oem-manufacturing"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.documentElement.classList.add('js');

  function initOemRacing(root) {
    if (!root || root.dataset.oemRacingInitialized === 'true') {
      return;
    }

    root.dataset.oemRacingInitialized = 'true';
    var revealItems = root.querySelectorAll('[data-reveal]');

    if (!('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    revealItems.forEach(function (item) {
      observer.observe(item);
    });

    root.oemRacingObserver = observer;
  }

  function initAllOemRacing() {
    document.querySelectorAll('.oem-racing-section').forEach(initOemRacing);
  }

  document.addEventListener('DOMContentLoaded', initAllOemRacing);
  document.addEventListener('shopify:section:load', function (event) {
    initOemRacing(event.target.querySelector('.oem-racing-section'));
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('.oem-racing-section');
    if (root && root.oemRacingObserver) {
      root.oemRacingObserver.disconnect();
      delete root.oemRacingObserver;
    }
  });

  initAllOemRacing();
})();

  } catch(e) { console.error(e); }
})();
})();
